<template>
  <el-card shadow="hover" style="margin-left: 10px;margin-top: 10px;width: 97%">
    <template #header>
      <div style="font-size: 20px;text-align:center;">个人信息
      </div>
    </template>
    <el-form title="个人信息" label-width="90px">
      <el-row>
        <!--        <el-col :span="12">-->
        <!--          <el-form-item prop="phone" label="手机号">-->
        <!--            <span style="font-size: medium;">{{ userInfo.phone }}</span>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-form-item prop="nickName" label="昵称">
            <div>
            <span style="font-size: medium;">{{ userInfo.nickName }}
              </span>
              <el-button type="primary" @click="showNickNameChange = true"> 修改</el-button>
            </div>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="createdTime" label="创建日期">
          <span style="font-size: medium">{{ userInfo.createdTime }}</span>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="vipEndTime" label="vip失效日期">
          <span style="font-size: medium;color: orangered">{{ userInfo.vipEndTime }}</span>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="vipEndTime" label="积分">
          <span style="font-size: medium;color: orangered">{{ userInfo.pointCardScore }}</span>
        </el-form-item>
      </el-row>

      <!--        <el-form-item prop="password" label="密码">-->
      <!--          <el-button type="primary" @click="showPasswordChange = true"> 修改</el-button>-->
      <!--        </el-form-item>-->


    </el-form>
  </el-card>
    <el-dialog v-model="showNickNameChange" title="修改昵称" width="30%">
      <el-form-item prop="" label="昵称">
        <el-input v-model="newNickName" type="text" placeholder="请输入新昵称"></el-input>

      </el-form-item>
      <span class="dialog-footer">
        <el-button @click="showNickNameChange=false" style="float: right;margin-left: 20px">取 消</el-button>
        <el-button type="primary" @click="modifyNickName" style="float: right;margin-left: 20px">确 定</el-button>
      </span>
    </el-dialog>
    <!--    <el-dialog v-model="showPasswordChange" title="修改密码" width="30%">-->
    <!--      <el-form-item prop="" label="旧密码">-->
    <!--        <el-input v-model="oldPassword" type="password" placeholder="请输入旧密码"></el-input>-->
    <!--      </el-form-item>-->
    <!--      <el-form-item prop="" label="新密码">-->
    <!--        <el-input v-model="newPassword" type="password" placeholder="请输入新密码"></el-input>-->
    <!--      </el-form-item>-->
    <!--      <span class="dialog-footer">-->
    <!--        <el-button @click="showPasswordChange=false" style="float: right;margin-left: 20px">取 消</el-button>-->
    <!--        <el-button type="primary" @click="modifyPassword" style="float: right;margin-left: 20px">确 定</el-button>-->
    <!--      </span>-->
    <!--    </el-dialog>-->

</template>

<script>

import request from "../../utils/request";
import {onMounted, reactive, ref} from "vue";
import router from "@/router";
import {ElMessage} from "element-plus";


let userId = localStorage.getItem("loginUserId");
let modifyNickNameSuccess = false;

async function modifyNickName(newNickName) {
  await request.put('/userInfo/modifyNickName',
      {
        id: userId,
        nickName: newNickName,
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code !== "200" && result.msg !== "") {
          ElMessage.error(result.msg);
        } else {
          ElMessage.info("更新成功");
          modifyNickNameSuccess = true;
        }
      })
      .catch(error => {
        console.error("sendPhoneConfirmCode error:" + error);
        // ElMessage.info("系统异常，请联系管理员");
      })
}

// let modifyPasswordSuccess = false;
// async function modifyPassword(newPassword, oldPassword) {
//   await request.put('/userInfo/modifyPassword',
//       {
//         userId: userId,
//         newPassword: newPassword,
//         oldPassword: oldPassword,
//       }).then(response => {
//     const result = response.data; // 将接口返回的数据赋值给result
//     if (result.code !== "200" && result.msg !== "") {
//       ElMessage.error(result.msg);
//     } else {
//       ElMessage.warning("更新成功");
//       modifyPasswordSuccess = true;
//     }
//   }).catch(error => {
//     console.error("sendPhoneConfirmCode error:" + error);
//     // ElMessage.info("系统异常，请联系管理员");
//   })// ;
// }


const newNickName = ref('');
// const newPassword = ref('');
// const oldPassword = ref('');
export default {
  name: "UserInfo",
  setup() {
    // 定义响应式数据
    const userInfo = reactive({
      phone: '',
      nickName: '',
      createdTime: '',
      vipEndTime: '',
      pointCardScore: '',
    });
    const getUserInfo = async () => {
      await request.get('/userInfo/',
          {
            params: {
              userId: userId,
            }
          }).then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          userInfo.phone = result.data.phone;
          userInfo.nickName = result.data.nickName;
          userInfo.createdTime = result.data.createdTime;
          userInfo.vipEndTime = result.data.vipEndTime;
          userInfo.pointCardScore = result.data.pointCardScore;
        } else {
          ElMessage.warning(result.msg);
          router.push("/login");
        }
      }).catch(error => {
        console.error("sendPhoneConfirmCode error:" + error);
        // ElMessage.info("系统异常，请联系管理员");
      })
    }
    onMounted(getUserInfo);
    return {
      userInfo: userInfo,
    }
  },
  data() {
    return {
      showNickNameChange: false,
      newNickName: newNickName,
      // showPasswordChange: false,
      // newPassword: newPassword,
      // oldPassword: oldPassword,
    }
  },
  methods: {
    async modifyNickName() {
      await modifyNickName(newNickName.value);
      if (modifyNickNameSuccess) {
        this.userInfo.nickName = newNickName.value;
        localStorage.setItem("loginNickName", newNickName.value);
        this.showNickNameChange = false;
      }
    },
    // async modifyPassword() {
    //   await modifyPassword(newPassword.value, oldPassword.value);
    //   if (modifyPasswordSuccess) {
    //     this.showPasswordChange = false;
    //     await router.push("/login");
    //   }
    // }
  }
}
</script>

<style scoped>
.rounded-border {
  border: 1px solid white; /* 设置边框 */
  border-radius: 10px; /* 设置圆角 */
  padding: 10px;
  width: 90%;
  text-align: center;
  margin-left: 10px;
  background-color: white;
}
</style>
